import { Component, OnInit } from '@angular/core';
import { Trade } from '../../models/trade';
import { OrderService } from '../../services/order.service';
import { SocketService } from '../../services/SocketService';
import { UserService } from '../../services/user.service';
import { StateService } from '../../services/state.service';
import { FirstCC, SecondCC } from '../../helpers/pipes';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { Oco } from '../../models/oco.model';
import { Order } from '../../models/orderbook.model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  getAllOrdersSelector,
  getCurrencyMappingsSelector,
  getCurrencyPairsSelector,
  getOrdersSelector,
  getSelectedOnBehalfUserSelector,
  getSpotPricesSelector
} from '../../store/state/selectors/matchboard.selectors';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import { CurrencyDto } from '../../models/CurrencyDto';
import { PriceService } from '../../services/price.service';

@Component({
  selector: 'app-cancel-modal',
  templateUrl: './cancel-modal.component.html'
})
export class CancelModalComponent implements OnInit {

  public mask = [];
  public amask = [];
  public qmask = [];

  selectedTenorId: any;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: any = {};
  trade: Trade;
  isSuperUser: boolean;
  ocos: Oco[];
  isOcoActive: boolean;
  swapPriceFactor: number;
  swapRate: number;
  baseOrder: Order;
  amount: number;

  currencyPairs: CurrencyDto[];

  selectedOnBehalfUser: string;

  spotPrices: any;

  currencyMappings: any;

  constructor(
    private bsModalRef: BsModalRef,
    private orderService: OrderService,
    private socketService: SocketService,
    private userService: UserService,
    private stateService: StateService,
    private firstCC: FirstCC,
    private secondCC: SecondCC,
    private readonly store: Store<MatchBoardState>,
    private readonly priceService: PriceService
  ) {
  }

  close() {
    this.bsModalRef.hide();
  }

  cancelOrder() {
    const arr = [];
    arr.push(this.trade.orderId);
    if (this.isSuperUser) {
      this.socketService.send('cancelOrder', {orderIds: arr, userId: this.selectedOnBehalfUser});
    } else {
      this.socketService.send('cancelOrder', {orderIds: arr});
    }
    this.close();
  }

  getFirstCC(sixLetterCode: string) {
    return sixLetterCode.substring(3, 6);
  }

  ngOnInit() {
    let orders = [];

    if (this.userService.isSuperUser()) {
      this.store.select(getAllOrdersSelector).subscribe((ordersState) => {
        orders = Object.values(ordersState);
      });
    } else {
      this.store.select(getOrdersSelector).subscribe((ordersState) => {
        orders = Object.values(ordersState);
      });
    }

    this.store.select(getCurrencyMappingsSelector).subscribe((currencyMappings) => {
      this.currencyMappings = currencyMappings;
    });

    this.store.select(getSpotPricesSelector).subscribe((spotPrices) => {
      this.spotPrices = spotPrices;
    });

    this.store.select(getCurrencyPairsSelector).subscribe((currencyPairs) => {
      this.currencyPairs = currencyPairs;
    });

    this.store.select(getSelectedOnBehalfUserSelector).subscribe((selectedUser) => {
      this.selectedOnBehalfUser = selectedUser;
    });


    const openedOrder = orders.find(item => item.id === this.trade.orderId);
    if (openedOrder.ocoLinkId) {
      if (openedOrder.ocoLinkId === openedOrder.id) {
        this.baseOrder = openedOrder;
      } else {
        this.baseOrder = orders.find(item => item.id === openedOrder.ocoLinkId);
      }
    } else {
      this.baseOrder = openedOrder;
    }
    this.amount = this.getBaseOrderAmount();
    this.swapPriceFactor = this.getCpFactor(this.baseOrder.sixLetterCode);
    this.userService.isSuperUser() ? this.isSuperUser = true : this.isSuperUser = false;
    this.dropdownList = [];

    this.selectedItems = [];

    if (this.baseOrder.ocoLinkId) {
      let i = 1;
      orders.filter(o => o.ocoLinkId === this.baseOrder.ocoLinkId).forEach(o => {
        if (o.isInverted) {
          this.selectedItems.push({
            id: i,
            itemName: this.secondCC.transform(o.sixLetterCode)
          });
        } else {
          this.selectedItems.push({
            id: i,
            itemName: this.firstCC.transform(o.sixLetterCode)
          });
        }
        i++;
      });
    } else {
      this.selectedItems = [
        {id: 1, itemName: this.getFirstCC(this.trade.sixLetterCode)}
      ];
    }

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      disabled: true
    };

    this.mask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: 2,
      decimalSymbol: '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: true,
      integerLimit: 13,
    });

    this.amask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: 2,
      decimalSymbol: '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: false,
      integerLimit: 13,
    });

    this.qmask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: 2,
      decimalSymbol: '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      allowNegative: false,
      integerLimit: 13,
    });

    // this.swapRate = Number((this.getDaysDividerToSwapRateByTradeType(this.baseOrder.swap) * this.baseOrder.profit / this.stateService.getSpotPriceForCurrencyPair(this.baseOrder.sixLetterCode) * 100).toFixed(2));
    this.swapRate = Number((this.getDaysDividerToSwapRateByTradeType(this.baseOrder.swap) * this.baseOrder.profit / this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, this.baseOrder.sixLetterCode) * 100).toFixed(2));

    this.ocos = [];

    this.trade.ocoLinkId ? this.isOcoActive = true : this.isOcoActive = false;

    if (this.isOcoActive) {
      orders.filter((o: Order) => {
        if (o.ocoLinkId === this.baseOrder.ocoLinkId && o.ocoLinkId !== o.id) {
          this.ocos.push(new Oco(
            o.sixLetterCode,
            o.profit,
            o.quantity,
            Number(((o.profit * this.getDaysDividerToSwapRateByTradeType(o.swap)) / this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, o.sixLetterCode) * 100).toFixed(2)),
            Number((o.quantity * (o.profit + this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, o.sixLetterCode))).toFixed(2))
          ));
        }
      });
    }
  }

  getDaysDividerToSwapRateByTradeType(swapType) {
    if (swapType === 'ON' || swapType === 'TOD_TOM') {
      return 365;
    }
    if (swapType === 'W1') {
      return 52;
    }

    return 26;
  }

  getCpFactor(sixLetterCode) {
    const cu = this.currencyPairs.find(cp => cp.sixLetterCode === sixLetterCode);
    if (!cu) {
      return 1;
    }
    return cu.swapPriceFactor;
  }

  getBaseOrderAmount() {
    return this.baseOrder.quantity * (this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, this.baseOrder.sixLetterCode));
  }
}
